/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ButtonIcon = ({ width = 24, height = 24, hidden = false, title = 'Button' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M26 8H10a10 10 0 0 0 0 20h16a10 10 0 0 0 0-20Zm0 18.1H10a8.1 8.1 0 0 1 0-16.2h16a8.1 8.1 0 0 1 0 16.2Z"
    />
    <path d="M26 12.1H10a5.9 5.9 0 0 0 0 11.8h16a5.9 5.9 0 0 0 0-11.8Z" />
  </svg>`;
};
